import { useCallback, useState } from 'react'
import { toast } from 'sonner'

interface CopyTextProps {
  value?: string
  testId: string
}

export function useCopyText({ value, testId }: CopyTextProps) {
  const [isCopied, setIsCopied] = useState(false)

  const copyInviteLink = useCallback(async () => {
    if (!value) return

    const isNotPossibleCopyIt =
      !navigator.clipboard || !navigator.clipboard.writeText

    if (isNotPossibleCopyIt) {
      return toast.info(
        'Seu navegador não suporta copiar para a área de transferência automaticamente. Por favor, copie manualmente.',
        {
          className: `${testId}-toast-warning`,
        },
      )
    }

    try {
      await navigator.clipboard.writeText(value)
      setIsCopied(true)
      setTimeout(() => setIsCopied(false), 2000)
    } catch {
      toast.error(
        'Não foi possível copiar o link. Por favor, copie manualmente.',
        {
          className: `${testId}-toast-error`,
        },
      )
    }
  }, [testId, value])

  return { isCopied, copyInviteLink }
}
